module.exports = __webpack_public_path__ + "img/vespa_350.ca5db392.png";